import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';

import 'slick-carousel';
import 'Lib/jquery.scrolltofixed';
import 'Lib/jquery.waypoints';
import 'Lib/jquery.panelsnap';

import * as track from '../track';
import OneSwatches from 'Modules/module-oneSwatches';
import OneZoom from 'Modules/module-oneZoom';
import OneSocial from 'Modules/module-oneSocial';
import OneTab from 'Modules/module-oneTab';
import OneVideo from 'Modules/module-oneVideoAutoplay';
import OneQuickShop from 'Modules/module-oneQuickShop';


"use strict";

var ViewProduct = Backbone.View.extend({

    selectors: {
        addToCart: '[data-add-to-cart]',
        addToCartText: '[data-add-to-cart-text]',
        comparePrice: '[data-compare-price]',
        comparePriceText: '[data-compare-text]',
        originalSelectorId: '[data-product-select]',
        priceWrapper: '[data-price-wrapper]',
        productFeaturedImage: '[data-product-featured-image]',
        productJson: '[data-product-json]',
        productPrice: '[data-product-price]',
        productThumbs: '[data-product-single-thumbnail]',
        singleOptionSelector: '[data-single-option-selector]'
    },

    initialize: function(opts){
        var self = this;


        self.$content = self.$el;
        self.$productInfo = self.$content.find('.product-info');
        self.$productGiftCard = self.$content.find('.product-single');
        self.$media = self.$content.find('.product-media').first();
        self.$relatedProducts = self.$content.find('.related-products');
        self.$mainImage = self.$media.find('#ProductPhoto');//Medium screen
        self.$thumbImage = self.$media.find('#ProductThumbs');//Large screen
        self.$sliderNav = self.$media.find('#productSliderNav');
        self.$sliderFor = self.$media.find('#productSliderFor');
        self.$mediaSlider = self.$mainImage.find('.images-wrapper');
        self.$addToCartBtn = self.$content.find('#AddToCart');
        self.$socialIcons = self.$content.find('.one-social');
        self.$groups = self.$content.find('.groups');
        self.$mobileStickyContainer = self.$content.find('.product-sticky-container');
        
        self.isGiftCard = self.$productGiftCard.hasClass('gift-card');
        self.isBundle = self.$content.hasClass('bundle');
        self.productJSON = $(self.selectors.productJson).length ? JSON.parse($(self.selectors.productJson).html()) : false;

        self.productMedia();
        self.qtyControl();
        self.addToCartMessage();
        self.updateInfoAnchorTarget();
        self.social();
        self.track();
        self.initVideo();

        if (!self.isBundle) {
            self.swatches();
            //self.productInfoFix();
            self.mobileStickyBag();
        } else {
            self.bundles();
        }

        if (!self.isGiftCard) {
            // self.tabs();
            self.toggle();
            self.modal();
            self.zoom();
            // self.productSiblings();
            // self.minicartTimer();
            if(self.$groups.length > 0){
                self.groupedSwatches();
                self.productSiblingsSortGrouped();
            } else {
                self.productSiblingsSort();
            }
        } else {
            self.giftcardValueControl();
        }

        if (self.$relatedProducts.length) {
            // self.relatedProducts();
        }

        self.listrack();

        OneQuickShop.init({
            el: $('.product-style-with'),
            isProductPage: true
        });
    },

    events: {

    },

    track: function () {
        var cache = window.ORW.caches.products;

        var variantId = null;
        try {
            variantId = link.href.match(/variant=([^&#]+)/)[1];
        } catch (_) {}

        cache.get(window.location.pathname + '.js')
            .done(function (_product) {
                var product = JSON.parse(JSON.stringify(_product));
                product.variant = product.variants.find(function (variant) {
                    return variant.id.toString() === variantId;
                }) || product.variants[0];

                if (window.ORW.utilities.getCookie('mrv_product') === product.title) {
                    return;
                }

                track.productDetailPage(product);
                window.ORW.utilities.setCookie('mrv_product', product.title);
            });

        track._.onCreate(
            document.body,
            '.groups .tab-toggle',
            function (toggle) {
                var link = $('.groups .tab[data-tab="' + toggle.dataset.tab + '"').find('a.sibling-link').get(0);
                if (!link) return;

                var handle = track._.getHandleForPathname(link.pathname);

                var position = function () {
                    track._.getElementIndex(toggle);
                };

                cache.get('/products/' + handle + '.js')
                    .done(function (_product) {
                        if (toggle.matches('.active')) return;

                        var product = JSON.parse(JSON.stringify(_product));
                        product.variant = product.variants[0];

                        track.productImpression(product, 'tabs', position());
                    });
            }
        );
    },

    groupedSwatches: function(){
        var self = this;

        var events = {
            'click .groups .tab-toggle:not(.active)': function(e){
                var content = $(e.currentTarget).data('tab');
                var $swatches = $('.groups .tab[data-tab="' + content + '"]');
                var redirect = $swatches.find('a.sibling-link').first().attr('href');

                // track this click
                {
                    var handle = track._.getHandleForPathname(redirect);

                    var position = function () {
                        track._.getElementIndex(e.currentTarget);
                    };

                    window.ORW.caches.products.get('/products/' + handle + '.js')
                        .done(function (_product) {
                            var product = JSON.parse(JSON.stringify(_product));
                            product.variant = product.variants[0];

                            track.productClick(product, 'template-product-tabs', 'tabs', position());
                        });
                }

                window.location = redirect;
            }
        };

        _.extend(self.events, events);
        self.delegateEvents();
        
        // The grouped swatches can still be managed with OneTab, however
        // in this case we only want to switch the tabs after a new product has loaded.
        // if(self.$groups.hasClass('tab-container')){
        //     OneTab.init({
        //         el: self.$groups
        //     });
        // }
    },

    bundles: function(){
        var self = this;
        self.swatchScopes = {};
        initBundles();

        function initBundles(bundledProduct) {
            
            self.$bundleProducts = self.$content.find('.bundled-product');
            self.$bundleProdsToLoop = bundledProduct ? bundledProduct : self.$bundleProducts;
            
            $('#AddBundleToCart').addClass('disabled').prop('disabled', true);
            
            _.each(self.$bundleProdsToLoop, function(bundle){
                var $product = $(bundle),
                onesize = $product.find('.bundle-swatch.swatch-os').length > 0 ? true: false,
                pid = $product.data('id'),
                pdata = $product.find('[data-product-json]').length ? JSON.parse($product.find('[data-product-json]').html()) : false,
                pidSelector = 'productSelect-' + pid;
                
                $product.find('.product-single__variants').attr('id', pidSelector);

                new Shopify.OptionSelectors( pidSelector , {
                    product: pdata,
                    enableHistoryState: true,
                    // onVariantSelected: ShopifyAPI.selectCallback
                });
                self.swatchScopes['scope_' + pid] = new OneSwatches.init({ el: $product, preSelect: onesize, product: pdata, bundle: true, selectIndex: pid });
            });
            
            if(self.$bundleProducts.length == self.$content.find('.bundle-swatch.active').length){
                $('#AddBundleToCart').removeClass('disabled').prop('disabled', false);
            }
        }

        function getBundleSibling(e){
            var self = this;

            e.stopPropagation();
            e.preventDefault();
            console.log('ajax!')
            var $curr = $(e.currentTarget);
            var $bundleParent = $curr.parents('.bundled-product');
            var pid = $bundleParent.data('id');
            // var titlePrefix = pid == 1 ? '1. Pick Your' : '2. Pair With a'
            
            if (url) {
                var url = url + '?view=bundle';
            } else {
                var url = $curr.data('url') ? $curr.data('url') + '?view=bundle' : $curr.attr('href') + '?view=bundle';
            }
            
            if (url == '#?view=bundle') {
                // Skip the empty URL 
                return false;
            }
            $.ajax({
                async: true,
                type: 'GET',
                url: url,
                cache: true,
                error: function(err) { 
                    console.log(err);
                },
                success: function(html) {
                    var $oldbundeledProductCore = $bundleParent.find('.bundled-product-core');
                    var $bundeledProductCore = $(html).find('.bundled-product-core');

                    var bundleHtml = $bundeledProductCore[0].outerHTML;
                    $bundeledProductCore.remove();
                    
                    $oldbundeledProductCore.remove();
                    $bundleParent.append(bundleHtml);
                    
                    self.swatchScopes['scope_' + pid].destroy();
                    initBundles($bundleParent)
                }
            });
        }

        function addAllToBag(e) {
            // Add All requires Quickbuy
            var self = this;
            e.preventDefault();
            
            // Add CTA status change here..
            // debugger;
            // Collecting data
            var productIdsString = "";
            var itemsToAdd = [];
            _.each(self.$bundleProducts, function(product){

                var $productSelected = $(product).find('select.product-single__variants');
                if ($productSelected.length) {
                    var variantID = $productSelected.val();
                    var quantity = 1;
                    productIdsString += variantID + ":" + quantity + ",";
                    itemsToAdd.push({
                        "variantID": variantID,
                        "quantity": quantity
                    });
                }
            });

            console.log(itemsToAdd);
            console.log(productIdsString);

            productIdsString = productIdsString.slice(0, -1);//trim trailing comma

            // Push product(s) to queue
            var bundlePropertyAdded = false;
            var date = new Date();
            var timestamp = date.getTime();
            
            _.each(itemsToAdd, function(item){
                var properties = {
                    '_bundle_qty': item.quantity,
                    _timestamp: timestamp,
                };
                if(bundlePropertyAdded == false){
                    properties._bundle_ids = productIdsString;
                    bundlePropertyAdded = true;
                }
                push_to_queue(item.variantID, item.quantity, properties);
                console.table(properties);
            });
            // Process the queue. Works when Shopify.queue has items in it
            ShopifyAPI.moveAlong();
            
        }

        function enableAddToCart(e){
            var $swatches = self.$content.find('.swatches');

            // console.log($swatches);
            console.log("swatches");
        }

        var events = {
            'click #AddBundleToCart' : addAllToBag,
            'click .sibling-link' : getBundleSibling,
        }
        
        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();
    },
    
    qtyControl: function(){
        var self = this;
        self.$qtyContainer = self.$productInfo.find('.product-qty-container');
        self.$qtyInput = self.$qtyContainer.find('#Quantity');
        self.$qtyControl = self.$qtyContainer.find('.qty');
        
        // Click outside to close
        $(window).on('click', function (e) {
            self.$qtyContainer.removeClass('opened');
        });
        
        var events = {
            'click .qty': function(e){
                e.stopPropagation();
                self.$qtyContainer.toggleClass('opened');
            },
            'click .product-qty-container [data-select]':function(e){
                var currentQty = $(e.currentTarget);
                self.$qtyInput.val(currentQty.data('select')).trigger('change');

            }
        };

        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();

    },
    
    giftcardValueControl: function () {
        var self = this;
        self.$valueContainer = self.$productInfo.find('.giftcard-value-wrapper');
        self.$valueInput = self.$valueContainer.find('#Value');
        self.$valueControl = self.$productInfo.find('#productSelect')
        
        // Close on clickaway
        $(window).on('click', function (e) {
            self.$valueContainer.removeClass('opened');
        });
        
        var events = {
            'click .giftcard-value': function (e) {
                e.stopPropagation();
                self.$valueContainer.toggleClass('opened');
            },
            'click .giftcard-value-wrapper [data-select]': function (e) {
                var currentValue = $(e.currentTarget);
                console.log(self.$valueControl);
                console.log(currentValue.data('title'));
                console.log( currentValue.data('select'));
                self.$valueInput.val(currentValue.data('title')).trigger('change');
                self.$valueControl.val(currentValue.data('select')).trigger('change');
                console.log(self.$valueControl, currentValue.data('select'));
            },
            'change .giftcard-value #Value': function (e){
                
                self.$valueContainer.find('li').not('[data-title="' + $(e.currentTarget).val() + '"]').removeClass('active');
                $('[data-title="' + $(e.currentTarget).val() + '"]').addClass('active');
            }
        };

        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();
    },

    initVideo: function(){
        var self = this;
        self.$videoBoxes = self.$media.find('.video-box');

        OneVideo.init({
            el: self.$videoBoxes,
            background: true
        });
        console.log('init the pdp alt video');

        const options = {
            root: null,
            threshhold: 0,
            rootMargin: "0px"
        }

        let bigVideo = $("#ProductThumbs").find(".video-box");
        console.log(bigVideo);
        console.log("big video")
        let playButton = $("#ProductThumbs").find('.video-ctl');
        console.log(playButton);
        console.log("play button vanilla")
        let bigVideoVanilla = $('#ProductThumbs').find('.video-box')[0];
        
        let count=0
        const observer = new IntersectionObserver(function(entries, observer) {
            entries.forEach(entry => {
                if (count >=1) {
                    console.log(entry);
                    playButton.click();
                } else {
                    count++
                }
            });
        }, options);
        if(bigVideoVanilla !== undefined) {
            observer.observe(bigVideoVanilla);
        }
    },

    social: function(){
        var self = this;
        var brand = 'White+Warren';
        //var description = self.$content.find('.product-description .tabs-content .active').length ? self.$content.find('.product-description .tabs-content .active').text() : self.$content.find('.product-description .tab-container').text();
        var description = '';

        OneSocial.init({
            el: self.$el,
            title: self.$content.find('h1').text(),
            description: description,
            image: function(){
                var $image = $('<img>');
                if (self.isMobile()) {
                    $image = self.$content.find('.slick-active img');
                } else {
                    $image = self.$content.find('.ps-active img');
                }
                return $image.prop('src');
            },
            pinterestTag: '#' + brand,
            twitterTag: '@' + brand,
        });

    },

    swatches: function(){
        var self = this;
        var $form = self.$content.find('form'),
            onesize = $form.hasClass('onesize');
            
        // Init Shopify option selector
        // Option init and Swatch init needed to be separated
        new Shopify.OptionSelectors('productSelect', {
            product: self.productJSON,
            onVariantSelected: ShopifyAPI.selectCallback,
            enableHistoryState: true
        });
        OneSwatches.init({ el: self.$content, preSelect: onesize, product: self.productJSON, isProductPage: true });

        var $variantContainer = self.$content.find('.selector-wrapper > .swatches').first();
        if($variantContainer.find('li').length < 2){
            $variantContainer.find('li').first().trigger('click');

            var selectOptions = self.$productInfo.find('#productSelect').find('option');
            if(selectOptions.length < 2){
                if(selectOptions.first().attr('disabled')){
                    self.$productInfo.find('.selector-wrapper.single-item').removeClass('opened');
                    self.$productInfo.find('.selector-wrapper.single-item').find('.swatch').removeClass('active').addClass('disabled');
                }
            }
        }
    },
    
    productInfoFix: function(){
        var self = this;
        var marginOffset = 35;
        var $elemToFix = self.$productInfo;
        
        self.$currentFixItems = false;
        
        if (!self.isMobile()) {
            self.$currentFixItems = $elemToFix.scrollToFixed({
                removeOffsets: true,
                spacerClass: 'fixed',
                fixed: function(){
                    $(this).removeClass('unFixed');
                    $(this).addClass('isFixed');
                },
                unfixed: function() {
                    $(this).removeClass('isFixed');
                    $(this).addClass('unFixed');
                },
                limit: function() {
                    // var limit = $('#fix-stopper').offset().top - $elemToFix.outerHeight() - marginOffset;
                    var limit = self.$media.outerHeight() - $elemToFix.outerHeight();
                    if (!limit) {
                        limit = 0.01;
                    }
                    return limit;
                },
                zIndex: 1,
            });
        }
        
    },
    
    productMedia: function(){
        var self = this;

        // Desktop Image Slider
        self.$sliderNav.on('init', function(event, slick, direction) {
            self.slick = slick;
            self.$sliderNav.find('.slick-current').addClass('slick-target');
        });
        self.$sliderFor = self.$sliderFor.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
        })
        self.$sliderNav = self.$sliderNav.slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            vertical: true,
            infinite: false
        });
        
        // Mobile Image Slider
        self.$mediaSlider.on('init', function(event, slick, direction){
            self.slick = slick;
            self.$mediaSlider.find('.video-block').height(self.$mediaSlider.height());
        });
        self.$mediaSlider.on('afterChange', function(event, slick, currentSlide, nextSlide){
            let currentSlideMarkup = slick.$slides[currentSlide];
            
            const imageSlideElem = currentSlideMarkup.querySelector('.js-image-slide');
            if (imageSlideElem && imageSlideElem.classList.contains('video-slide')) {
                const video = imageSlideElem.querySelector('.js-video');
                if (!video) return;
                
                video.muted = true; // Ensure video is muted to allow autoplay
                video.play().catch(error => {
                    console.error("Autoplay prevented:", error);
                });
            }

            /* Original code ...
            if ($(currentSlideMarkup).hasClass("video-slide")) {
                console.log(`video slide`);
                let playButton = $(currentSlideMarkup).find(".video-ctl");
                $(playButton).trigger("click");
            } */
        });
        
        self.$mediaSlider = self.$mediaSlider.slick({
            dots: true,
            infinite: true,
            speed: 600,
            slidesToShow: 1,
            arrows: false,
            lazyLoad: 'progressive'
        });

        var events = {
            'click .product-single__slider__nav .slick-slide' : function(e) {
                let currentSlide = e.currentTarget;
                let currentSlideIndex = e.currentTarget.attributes["data-slick-index"].value;
                $('.product-single__slider__nav .slick-slide').removeClass('slick-target');
                currentSlide.classList.add('slick-target');
                $('#productSliderFor').slick('slickGoTo', currentSlideIndex, true);
            }
        };

        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();
    },

    modal:function(){
        var self = this;
        var modalSelector = 'modal';
        var activeModalBodyClass = 'modal-active';

        // <span class="detail-title" data-toggle="modal" data-modal="shipping-and-returns">{{ settings.product_shippingreturns_title }}</span>
        // <div class="info modal" id="shipping-and-returns" role="dialog"></div>

        var triggerModalClose = function(){
            $('.'+modalSelector).removeClass('active');
            $('body').removeClass(activeModalBodyClass);
        }

        var events = {
            'click [data-toggle="modal"]' : function(e){
                var targetModal = $(e.currentTarget).data('modal');
                console.log(targetModal);
                triggerModalClose();
                $('body').addClass(activeModalBodyClass);
                $('#'+targetModal).addClass('active');
            },
            'click .modal .icon-close' : function(e){
                triggerModalClose();
            }
        };

        $('.modal-overlay').click(function(){
            triggerModalClose();
        });

        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();

    },
    
    zoom: function(){
        var self = this;
        OneZoom.init({
            el: self.$media,
            mainImage: self.$mainImage,
            thumbImage: self.$thumbImage
        });
    },

    updateInfoAnchorTarget: function(){
        var self = this;

        var $selectAccordionsWrapper = self.$productInfo.find('.product-accordion');
        var $getAnchorsfromTabs = $selectAccordionsWrapper.find('a');

        _.each($getAnchorsfromTabs, function(child){
            var $child = $(child);
            if(typeof $child.attr('target') == 'undefined'){
                $child.attr('target','_blank');
            }
        });
    },

    tabs: function(){
        var self = this;
        var tabSwitch = function($elem, className){
            $elem.addClass(className);
            $elem.siblings().removeClass(className);
        };
        var tabUpdate = function(e){
            var $curr = $(e.currentTarget);
            var $tabContainer = $curr.parents('.tab-container');
            var tabVal = $curr.attr('data-tab');
            var $activeTab  = $tabContainer.find('.tabs-content [data-tab="' + tabVal + '"]');
            
            tabSwitch($curr, 'active');
            tabSwitch($activeTab, 'active');
        };

        var events = {
            'click .product-accordion .tab-titles div' : function(e){
                tabUpdate(e);
            }
        };
        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();
    },

    toggle: function(){
        var self = this;
        var events = {
            'click .product-accordion .tab-toggle' : function(e){
                $(e.currentTarget).siblings().removeClass('active');
                $(e.currentTarget).toggleClass('active');
            }
        };
        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();
    },
    
    responsive: function (flag) {
        // For window resize on Desktop
        var self = this,
        id = '',
        marginOffset = 0;
        
        function responsive(){
            var $fixItems = self.$currentFixItems || false;
            if ($fixItems && $fixItems.css('position') == 'absolute') {
                var limit = $('#fix-stopper').offset().top - $fixItems.outerHeight() - marginOffset;
                var itemTop = $fixItems.offset().top;
                // console.log('limit: ' + limit + ' / itemTop: ' + itemTop);
                if (itemTop > limit) {
                    $fixItems.css({ top: limit });
                }
            }
        };
        
        responsive();
        $(window).resize(function() {
            clearTimeout(id);
            id = setTimeout(function(){
                console.log('window resized');
                responsive();
            }, 400);
        });
        
    },
    
    productSiblings: function () {
        var self = this;

        var events = {
            'click .sibling-product-container' : function(e){
                e.stopPropagation();
                $(e.currentTarget).toggleClass('active');
                $(e.currentTarget).siblings().removeClass('active');
            },
            'click .sibling-product-container:not(.active) .active' : function(e){
                e.preventDefault();
            },
            'click .sibling-product-container:not(.active) a' : function(e){
                e.preventDefault();
                var ele = $(e.currentTarget);
                var list = ele.parents('.sibling-list');
                list.find('.active').removeClass('active');
                ele.parent('.list-item').addClass('active');
            }
        }

        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();
    },

    productSiblingsSort: function () {
        var self = this;
        const wrapper = $('.product-info-wrapper > .add-to-cart-form .sibling-product-container');
        const siblings = wrapper.find('.sibling-list.normalPrice .list-item[data-discount=false]');
        const normalPriceContainer = wrapper.find('#normalPrice');
        let activeSibling = siblings.filter('.list-item.active').first();
        if (activeSibling.length == 0) {
            activeSibling = siblings.first();
        }

        // Although we manage everything through liquid,
        // This fallback essentially allows us to have a trusted price value
        if (siblings.length > 0) {
            normalPriceContainer.text('$' + (activeSibling.data('price') / 100));
        } else {
            normalPriceContainer.text('');
        }
    },

    productSiblingsSortGrouped: function () {
        var self = this;
        const wrapper = $('.product-info-wrapper > .add-to-cart-form .tab.active .sibling-product-container');
        const siblings = wrapper.find('.sibling-list.normalPrice .list-item[data-discount=false]');
        const normalPriceContainer = wrapper.find('#normalPrice');
        let activeSibling = siblings.filter('.list-item.active').first();
        if (activeSibling.length == 0) {
            activeSibling = siblings.first();
        }

        // Although we manage everything through liquid,
        // This fallback essentially allows us to have a trusted price value
        if (siblings.length > 0) {
            normalPriceContainer.text('$' + (activeSibling.data('price') / 100));
        } else {
            normalPriceContainer.text('');
        }
    },

    addToCartMessage: function(){
        var self = this;

        var events = {
            'click #AddToCart:not(.disabled)': function(e){
                var $addToCartBtn = $(e.currentTarget);
                var originalCaption = $addToCartBtn.find('.add-to-cart-text').text();
                $addToCartBtn.find('.add-to-cart-text').addClass('added').text('Added to bag');
                setTimeout(function(){
                    $addToCartBtn.find('.add-to-cart-text').removeClass('added').text(originalCaption);
                },5000);
            }
        };

        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();
    },

    minicartTimer: function(){
        var self = this;

        var $addToCart = self.$content.find('.add-to-cart-btn');

        $addToCart.click(function(){
            if(!$addToCart.attr('disabled')){
                var minicartTimeOut = setTimeout(function(){
                    $('#MiniCart').find('.drawer-close').trigger('click');
                },4000);

                $('#MiniCart').hover(function(){
                    clearTimeout(minicartTimeOut);
                });
            }
        });

    },
    
    relatedProducts: function () {
        var self = this;
        var $scrollCta = self.$content.find('.scroll-to').addClass('active');
        var events = {
            'click .scroll-to' : function(e){
                $('html, body').animate({
                    scrollTop: self.$relatedProducts.offset().top
                }, 500);
            }
        }
        $scrollCta.scrollToFixed({
            removeOffsets: true,
            spacerClass: 'fixed',
            //dontSetWidth: 'not set',
            limit: function() {
                var limit = $('#fix-stopper').offset().top - self.$productInfo.find('.scroll-to').outerHeight();
                return limit;
            },
            zIndex: 1,
        });
        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();
    },
    
    isMobile: function () {
        var self = this;
        var w = $(window).width();
        if (w < ORW.responsiveSizes.medium) {
            return true;
        }
        return false;
    },

    mobileStickyBag: function() {
        var self = this;
        var stickyMenuTop = self.$mobileStickyContainer.offset().top; // gets offset of sticky menu
        var stickyMenuHeight = self.$mobileStickyContainer.outerHeight(); // gets height of sticky menu

        // self.$mobileStickyContainer.scrollToFixed({
        //     maxWidth: ORW.responsiveSizes.medium,
        //     dontSetWidth: true,
        //     fixed: function() { 
        //         this.classList.add('slide-in') 
        //     },
        // })

        function setSticky() {
            // Keep getting sticky container offset in case image loads slowly and causes sticky container to be higher than it normally is
            if (!self.$mobileStickyContainer.hasClass('fixed')) {
                stickyMenuTop = self.$mobileStickyContainer.offset().top;
            }

            if($(window).scrollTop() > stickyMenuTop + stickyMenuHeight){
                self.$mobileStickyContainer.addClass('fixed')
            }
            else{
                self.$mobileStickyContainer.removeClass('fixed')
            }
        }
        // set on page load in case scrolled down initially
        setSticky();
        // fix menu while scrolling
        $(window).scroll(function(){
            setSticky();
        });

        function setBodyOverflow() {
            var colorContainer = self.$mobileStickyContainer.find('.sticky-color-select');
            var sizeContainer = self.$mobileStickyContainer.find('.sticky-size-select');

            if (colorContainer.hasClass('open') || sizeContainer.hasClass('open')) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.overflow = '';
            }
        }
        
        var events = {
            // 'click .sticky-color-select .current-color' : function(e){
            //     var ele = e.currentTarget;
            //     var colorContainer = ele.closest('.sticky-color-select');
            //     if (colorContainer) {
            //         colorContainer.classList.toggle('open');
            //         setBodyOverflow(); 
            //     }
            // },
            'click .sticky-size-select .swatch-label,.sticky-size-select .swatch' : function(e){
                var ele = e.currentTarget;
                var sizeContainer = ele.closest('.sticky-size-select');
                if (sizeContainer) {
                    sizeContainer.classList.toggle('open');
                    setBodyOverflow();
                }
            }
        }

        $(document.body).on('completeAddItem.ajaxCart', function() {
            if (self.isMobile()) {
                self.$mobileStickyContainer.css('z-index', 997);
            }
        });

        $(document.body).on('drawer-closing', function() {
            if (self.isMobile()) {
                self.$mobileStickyContainer.css('z-index', 1000);
            }
        });

        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();
    },

    listrack: function () {
        var self = this, events;

        function bisModalCtl(enable) {
            var $bis_modal = $('.ltk-bis');
            var activeModalBodyClass = 'modal-active';

            if ($bis_modal.length) {
                if (enable) {
                    $bis_modal.addClass('active');
                    $('body').addClass(activeModalBodyClass);
                } else {
                    $bis_modal.removeClass('active');
                    $('body').removeClass(activeModalBodyClass);
                }
            }
        }

        function submitCtl(e) {
            var $curr = $(e.currentTarget);
            var $bisForm = $curr.parents('.bis-form');
            var productSKU =  $bisForm.find('[name=txtProductSKU]').val();
            var emailAddress = $bisForm.find('[name=txtEmailAddress]').val();
            var alertCode = $bisForm.find('[name=hdnAlertCode]').val();

            if (!$bisForm || !$bisForm.length) {
                console.error('No BIS form found in DOM');
                return false;
            }

            if (!productSKU) {
                alert($bisForm.data('error'));
                return false;
            }

            if (!emailAddress) {
                alert($bisForm.data('error-email'));
                return false;
            } else {
                var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                var resutl = regex.test(emailAddress);
                if (!resutl) {
                    alert($bisForm.data('error-email'));
                    return false;
                }
            }

            _ltk.Alerts.AddAlert(emailAddress, productSKU, alertCode);
            _ltk.Alerts.Submit();
            alert($bisForm.data('success-msg'));
            bisModalCtl(false);
            return false;
        }

        (function(){if(typeof _ltk == 'object'){ltkCode();}else{(function (d) { if (document.addEventListener) document.addEventListener('ltkAsyncListener', d); else { e = document.documentElement; e.ltkAsyncProperty = 0; e.attachEvent('onpropertychange', function (e) { if (e.propertyName == 'ltkAsyncProperty') { d(); } }); } })(function(){ltkCode();});}function ltkCode(){_ltk_util.ready(function(){
            /********** Begin Custom Code **********/
            // _ltk.Activity.AddProductBrowse('SKU1'); 
            // alert(`LTK Tracking!!!`);
            /********** End Custom Code ************/

            events = {
                'click .notify-me' : function(e){
                    e.stopPropagation();
                    e.preventDefault();
                    bisModalCtl(true);
                },
                'click .notify-me-close': function(e){
                    bisModalCtl(false);
                },
                'click [name=SubmitAlert]': function(e){
                    e.preventDefault();
                    submitCtl(e);
                },
                'focus [name="txtEmailAddress"]': function(e){
                    // console.log('focus on email field!!');
                    _ltk.Signup.New('BISSignup', 'input[name="txtEmailAddress"]', _ltk.Signup.TYPE.CLICK, 'button[name="SubmitAlert"]');
                    _ltk.Signup.SetOptIn('BISSignup', 'bis_subscription');
                }
            }

            $('.modal-overlay').on('click', function(){
                bisModalCtl(false);
            });

            // Update and delegate adding events
            _.extend(self.events, events);
            self.delegateEvents();

        })}})();
    },

});

export default ViewProduct;